export const IQ_ASIACELL_PIN_LENGTH = 4;

const YEAR_FORMAT_PIN_REGEXP = /^(202[5-9]|2030)$/;

export const isYearFormatPin = (pin: string): boolean => YEAR_FORMAT_PIN_REGEXP.test(pin);

export const resolveServiceShortCode = (
  subscribeData?: { smsShortCode?: string | number | null },
  operatorSelectedDetails?: { smsShortCode?: string | number | null; shortCode?: string | number | null },
  fallbackShortCode?: string | null
): string | null => {
  const candidates = [
    subscribeData?.smsShortCode,
    operatorSelectedDetails?.smsShortCode,
    operatorSelectedDetails?.shortCode,
    fallbackShortCode,
  ];

  for (const candidate of candidates) {
    if (candidate == null || candidate === '') continue;
    return String(candidate);
  }

  return null;
};

export const isServiceShortCodePin = (pin: string, shortCode?: string | null): boolean => {
  if (!pin || !shortCode) return false;

  const normalizedShortCode = shortCode.replace(/\D/g, '');
  if (!normalizedShortCode) return false;

  if (normalizedShortCode === pin) return true;

  if (normalizedShortCode.length < IQ_ASIACELL_PIN_LENGTH) {
    return pin === normalizedShortCode.padStart(IQ_ASIACELL_PIN_LENGTH, '0');
  }

  if (pin.length === IQ_ASIACELL_PIN_LENGTH && normalizedShortCode.length >= IQ_ASIACELL_PIN_LENGTH) {
    return (
      normalizedShortCode.slice(0, IQ_ASIACELL_PIN_LENGTH) === pin ||
      normalizedShortCode.slice(-IQ_ASIACELL_PIN_LENGTH) === pin
    );
  }

  return false;
};

export const isBlockedPinValue = (
  pin: string,
  options: {
    enforceStrictRules?: boolean;
    serviceShortCode?: string | null;
  } = {}
): boolean => {
  if (!options.enforceStrictRules || pin.length !== IQ_ASIACELL_PIN_LENGTH) return false;

  return isYearFormatPin(pin) || isServiceShortCodePin(pin, options.serviceShortCode);
};

export const isValidPinLength = (
  pin: string,
  options: {
    enforceStrictRules?: boolean;
    expectedDigits?: number | null;
  } = {}
): boolean => {
  if (!pin) return false;

  if (options.enforceStrictRules) {
    return pin.length === IQ_ASIACELL_PIN_LENGTH;
  }

  if (options.expectedDigits) {
    return pin.length === options.expectedDigits;
  }

  return pin.length >= 4 && pin.length <= 6;
};
